import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, getFormData, uuid } from '../../common';
import { QuizShowRepository } from '../../repository/QuizShowRepository';

const repository = new QuizShowRepository();
const getAccountId = () => window.localStorage.getItem("quiz-show-account-id");
const setAccountId = (id) => window.localStorage.setItem("quiz-show-account-id", id);
const removeAccountId = () => window.localStorage.removeItem("quiz-show-account-id");
const showUserChangeNicknameModal = () => window.$("#quiz-show-game-list-page-change-name-modal").modal("show");
const hideUserChangeNicknameModal = () => window.$("#quiz-show-game-list-page-change-name-modal").modal("hide");
const hideUserJoinModal = () => window.$("#quiz-show-game-list-page-join-modal").modal("hide");

class QuizShowGameListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      gameList: [],
      userChangeNameModalOpen: true
    };
  }

  componentDidMount() {
    if (!getAccountId()) {
      window.$("#quiz-show-game-list-page-join-modal").modal("show");
      return;
    }

    this.fetchMe();
    this.fetchGameList();
  }

  fetchMe() {
    const accountId = getAccountId();
    repository.findMe({ accountId }, (data) => {
      this.setState({ user: data, userChangeNameModalOpen: true });
    }, () => {
      removeAccountId();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    });
  };

  fetchGameList() {
    repository.searchGame(null, (data) => {
      this.setState({ gameList: data.games });
    });
  };

  render() {
    const { user, gameList, userChangeNameModalOpen } = this.state;

    const onSubmitUserCreate = (e) => {
      e.preventDefault();
      const formData = getFormData(e.target);
      repository.createUser(formData, () => {
        setAccountId(formData.accountId);
        hideUserJoinModal();
        e.target.reset();
        this.fetchMe();
        this.fetchGameList();
      });
    };

    const onSubmitUserChangeName = (e) => {
      e.preventDefault();
      const formData = getFormData(e.target);
      const accountId = getAccountId();
      if (!formData.nickname) {
        window.Toast.danger("닉네임을 입력하세요");
        return;
      }

      repository.updateUser({ accountId, ...formData }, () => {
        hideUserChangeNicknameModal();
        this.fetchMe();
        setTimeout(() => {
          this.setState({ userChangeNameModalOpen: false });
        }, 300);
      });
    };

    return (
      <>
        <div style={{ marginTop: 30 }}>
          <QuizShowUserWrapper user={user} showUserChangeNicknameModal={showUserChangeNicknameModal} />
        </div>

        <div className={"container"} style={{ marginTop: 30 }}>
          <QuizShowGameList items={gameList} />
          <br />
        </div>

        <Modal id={"quiz-show-game-list-page-join-modal"} title={"회원가입"}>
          <QuizShowUserCreate onSubmit={onSubmitUserCreate} accountId={uuid()} />
        </Modal>

        <Modal id={"quiz-show-game-list-page-change-name-modal"} title={"닉네임변경"}>
          {userChangeNameModalOpen && (<QuizShowUserChangeNickname onSubmit={onSubmitUserChangeName} defaultValue={user.nickname} />)}
        </Modal>
      </>
    );
  }
}

const QuizShowUserWrapper = (props) => {
  const { user } = props;

  const onClickUserChangeName = (e) => {
    e.preventDefault();
    props.showUserChangeNicknameModal && props.showUserChangeNicknameModal();
  };

  return (
    <>
      <div style={{ fontSize: 28 }}>
        {user.nickname} <button className={"btn btn-sm btn-primary"} onClick={onClickUserChangeName}>변경</button>
      </div>
    </>
  );
};

const QuizShowUserChangeNickname = (props) => {
  const { defaultValue } = props;
  return (
    <form onSubmit={props.onSubmit}>
      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>닉네임</label>
        <input className={"form-control"} name={"nickname"} autoComplete={"off"} defaultValue={defaultValue} />
      </div>
      <br />
      <div className={"form-group"}>
        <input className={"form-control btn btn-primary"} type={"submit"} value={"진행하기"} />
      </div>
    </form>
  );
};

const QuizShowUserCreate = (props) => {
  const { accountId } = props;

  return (
    <form onSubmit={props.onSubmit}>
      <div className={"form-group"} style={{ textAlign: "left" }}>
        <label>닉네임</label>
        <input className={"form-control"} name={"nickname"} autoComplete={"off"} />
        <input type={"hidden"} name={"password"} defaultValue={accountId} />
        <input type={"hidden"} name={"accountId"} defaultValue={accountId} />
      </div>
      <br />
      <div className={"form-group"}>
        <input className={"form-control btn btn-primary"} type={"submit"} value={"진행하기"} />
      </div>
    </form>
  );
};

const QuizShowGameList = (props) => {
  const { items } = props;
  return (
    <div className={"list-group"}>
      {items.map((item, idx) => (
        <QuizShowGameListItem key={idx} item={item} />
      ))}
    </div>
  );
};

const QuizShowGameListItem = (props) => {
  const { item } = props;
  return (
    <Link className={"list-group-item list-group-item-action"} to={`/quizshow/${item.id}`}>{item.name}</Link>
  );
};

export { QuizShowGameListPage };
